exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thin-button-wrapper[data-v-0ecf3136] {\n  background-color: #e9f1fb;\n  display: flex;\n  flex-direction: column;\n  row-gap: 12px;\n  padding-left: 22px;\n  padding-top: 22px;\n  padding-right: 40px;\n  position: absolute;\n  height: 100vh;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n.sticky[data-v-0ecf3136] {\n  position: sticky;\n  height: 1px;\n  top: 50px;\n}", ""]);

// exports
